(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('AlarmService', AlarmService);

    AlarmService.$inject = ['$http', 'RequestService', 'ModalConstructor', 'AlertModalService'];

    function AlarmService($http, RequestService, ModalConstructor, AlertModalService) {

        var service = {
            // API Methods
            getAlarmList: getAlarmList,            
            getAlarmHistoryList: getAlarmHistoryList,
            getInterfaces: getInterfaces,
            getAlarmType: getAlarmType,
            getOltAlarmSettings: getOltAlarmSettings,
            saveOltAlarmSettings: saveOltAlarmSettings,
            getOnuAlarmSettings: getOnuAlarmSettings,
            saveOnuAlarmSettings: saveOnuAlarmSettings,
            clearAlarmHistory: clearAlarmHistory,
            // Modal Methods
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            settingsModalConstructor: settingsModalConstructor
            
        };

        return service;

        function getAlarmList(filters) {
            var expressionFilter = {};
            if (filters) {
                expressionFilter = constructFilter(filters);
            }
            return $http.get(apiUrl(), {params: expressionFilter}).then(responseData);

        }

        function getAlarmHistoryList(filters) {
            var expressionFilter = {};
            if (filters) {
                expressionFilter = constructFilter(filters);
            }
            return $http.get(apiUrl('pages'), {params: expressionFilter}).then(responseData);

        }
       
        function getInterfaces() {
            return $http.get(apiUrl('filters/interfaces')).then(responseData);
        }

        function getAlarmType() {
            return $http.get(apiUrl('filters/types')).then(responseData);
        }

        function getOltAlarmSettings(oltId) {
            return $http.get(apiUrl(oltId)).then(responseData);
        }

        function saveOltAlarmSettings(data) {
            return $http.put(apiUrl('updateoltalarmconfig'), data).then(responseData);
        }

        function getOnuAlarmSettings(oltId, onuId) {
            return $http.get(apiUrl(oltId + '/' + onuId)).then(responseData);
        }

        function saveOnuAlarmSettings(data) {
            return $http.put(apiUrl('updateonualarmconfig'), data).then(responseData);
        }

        function clearAlarmHistory() {
            return $http.put(apiUrl('clearalarmhistory')).then(responseData);
        }

        // Helper functions
        function apiUrl(method) {
            return RequestService.apiUrl('alarms', method);
        }

        function constructFilter(filters) {
            angular.forEach(filters, function (value, key, obj) {
                if (!value) {
                    delete obj[key];
                }
            });
            return filters;
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function errorModalConstructor(response, action) {
            AlertModalService.error(response, action, 'alarm');
        }

        function successModalConstructor(action, isMultiple) {
            AlertModalService.success(action, isMultiple, 'alarm');
        }

        function settingsModalConstructor() {
            var settings = {
                templateUrl: 'app/components/alarm/alarm-settings-modal.html',
                controller: 'AlarmSettingsController',
                controllerAs: 'vmAlarmSettings',
                size: 'sm',
                backdrop: true,
                appendTo: angular.element('.main'),
                windowClass: 'left'
            };
            ModalConstructor.open(settings);
        }

    }
})();